
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.6667 12.2166V16.6666C16.6667 17.1086 16.4911 17.5325 16.1785 17.8451C15.866 18.1577 15.442 18.3333 15 18.3333H3.33335C2.89133 18.3333 2.4674 18.1577 2.15484 17.8451C1.84228 17.5325 1.66669 17.1086 1.66669 16.6666V4.99992C1.66669 4.55789 1.84228 4.13397 2.15484 3.82141C2.4674 3.50885 2.89133 3.33325 3.33335 3.33325H7.78335","stroke":"#323444","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15 1.66675L18.3334 5.00008L10 13.3334H6.66669V10.0001L15 1.66675Z","stroke":"#323444","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    